import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@rocketlane/ui';
import React from 'react';
import { IdpType } from 'api/account';
import { ReactComponent as Google } from 'components/atoms/vendor-loign/google.svg';
import { useTranslate } from 'hooks/use-translation';
export const SsoSamlButton = ({ idp, googleSSOHandler, samlFlowHandler, isCognitoEnabled, oktaAuth, idpId })=>{
    const translate = useTranslate();
    return /*#__PURE__*/ _jsx(Button, {
        variant: "secondary",
        type: "button",
        leftIcon: idp.idpType === IdpType.Google ? /*#__PURE__*/ _jsx(Google, {}) : undefined,
        onClick: ()=>{
            if (isCognitoEnabled) {
                if (idp.idpType === IdpType.Google) {
                    googleSSOHandler();
                } else {
                    samlFlowHandler();
                }
                return;
            }
            if (!oktaAuth) {
                return;
            }
            oktaAuth.signInWithRedirect({
                idp: idpId
            });
        },
        children: idp.idpType === IdpType.Google ? translate('google.sign-in') : translate('sign_in.sso')
    }, idp.idpId);
};
